/*eslint-disable*/
import React from 'react'
import { withFormik, Field as Fieldmik } from 'formik';
import * as yup from 'yup';
import { Form as FormUi, Container, Button, Label, Modal, } from 'semantic-ui-react';
import APP_CONSTANT from '../../../config/constants'
import Axios from 'axios';
import { MyInput } from '../../apiInputComponent/myInput';
import cogoToast from 'cogo-toast';


const AddJobcardType = ({ values, errors, touched, isSubmitting, handleSubmit, handleClose }) => {
    return (
        <>
            <Modal.Content>
                <Container>
                    <div className="ui form">
                        <FormUi.Field>
                            <Fieldmik component={MyInput} error={values.jobcardTypeCode ? false : true} name="jobcardTypeCode" label="Jobcard Type Code *" placeholder="Code" />
                            {touched.jobcardTypeCode && errors.jobcardTypeCode ? <Label size="mini" prompt pointing>{errors.jobcardTypeCode}</Label> : ''}
                        </FormUi.Field>
                        <FormUi.Field>
                            <Fieldmik name="jobcardType" component={MyInput} error={values.jobcardType ? false : true} label="Jobcard Type *" placeholder="Type" />
                            {touched.jobcardType && errors.jobcardType ? <Label size="mini" prompt pointing>{errors.jobcardType}</Label> : ''}
                        </FormUi.Field>
                    </div>
                </Container>
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={handleClose} type="submit" size="tiny">Cancel</Button>
                <Button disabled={isSubmitting} onClick={handleSubmit} size="tiny" primary>Submit</Button>
            </Modal.Actions>
        </>
    )
}

const FormikJobcardType = withFormik({
    mapPropsToValues({ jobcardTypeCode, jobcardType }) {
        return {
            jobcardTypeCode: jobcardTypeCode || '',
            jobcardType: jobcardType || '',
        }
    },
    validationSchema: yup.object().shape({
        jobcardType: yup.string().matches(/^[A-Za-z-0-9]+$/, 'Invalid Characters').min(3, 'Must be more than 3 Letters').required('Jobcard Type Required'),
        jobcardTypeCode: yup.string().matches(/^[A-Za-z0-9]+$/, 'Invalid Characters').min(3, 'Must be more than 3 Letters').required('Jobcard Type Code Required')
    }),
    handleSubmit(values, { setErrors, setSubmitting, setSuccess }) {
        let jobcardTypeCode = values.jobcardTypeCode
        let jobcardType = values.jobcardType
        let token = localStorage.getItem('apiToken')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNo')
        let typeData = JSON.stringify({
            api_token: token,
            jobCardType: jobcardType,
            jobCardTypeCode: jobcardTypeCode,
            customerNumber: customerNo,
            userId: userId
        })

        Axios.put(`${APP_CONSTANT.BASE_URL}masters/jobCardType/`, typeData, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then(response => {
            if (response.data.status === 200) {
                cogoToast.success(response.data.message)
                setTimeout(() => {
                    window.location.reload()
                }, 500);
            } else {
                setSubmitting(false)
                cogoToast.error(response.data.message)
            }
        })
    }
})(AddJobcardType)

export default FormikJobcardType
